import { gql } from 'graphql-tag';
import React from 'react';
import get from 'lodash.get';
import { useRouteMatch } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { RedirectToUnhandledError } from '~/modules/common/unhandled-error';
import { projectDate2Fragment } from '~/modules/resourcing/common/fragments/specificProjectFragment';
import { RESOURCE_ALLOCATION_PERMISSION } from '~/modules/common/enums';
import { useMeContext } from '~/modules/me/useMeContext';

export const projectQuery = gql`
  query getProjectBySlug(
    $projectSlug: String!
    $includeResourceAllocationActions: Boolean = false
  ) {
    project(projectSlug: $projectSlug) {
      ...SpecificProjectDate2Fragment
      resourceAllocationActions
        @include(if: $includeResourceAllocationActions) {
        canViewResourceAllocation
        canEditResourceAllocation
      }
      copyProjectJobId
      budgetedCost {
        currency {
          id
          displayText
        }
      }
    }
  }
  ${projectDate2Fragment}
`;

export const useProjectInfo = () => {
  const {
    params: { slug }
  } = useRouteMatch();

  const {
    permissionsMap,
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  const canViewResourceAllocation = Boolean(
    permissionsMap[RESOURCE_ALLOCATION_PERMISSION.VIEW_RESOURCE_ALLOCATION]
  );

  const { loading, data, error } = useQuery(projectQuery, {
    variables: {
      projectSlug: slug,
      includeResourceAllocationActions:
        isPsaRmpEnhancedProjectManagerPersonaEnabled &&
        canViewResourceAllocation
    }
  });

  if (error) return <RedirectToUnhandledError />;

  const project = get(data, 'project', {});

  return { project, isLoading: loading, error };
};
